// extracted by css-extract-rspack-plugin
export default {"suggestions":"Kf7XRTN2fPgEVbNw","suggestionItem":"jLAxEZL6eEEeFJSH"};